export const getVideoMicrodata = (
  {
    title,
    contentUrl,
    thumbnailUrl,
    uploadDate,
    description
  }) => {
  return {
    '@type': 'VideoObject',
    'name': title,
    'description': description,
    'thumbnailUrl': thumbnailUrl,
    'uploadDate': uploadDate,
    'contentUrl': contentUrl
  }
}
